import { AnalyticIdentifier } from '@common/neo.tax';
import { Avatar, colors, Stack, Typography, useModal } from '@ui-components/neo.tax';
import { useMenuState, Menu as AriaMenu } from 'ariakit';
import { ReactElement } from 'react';

import { useCurrentUser } from '@neo.tax/shared/hooks';
import { useAnalyticId } from '@neo.tax/shared/state';
import { getPath, Path } from '@neo.tax/shared/utils';

import { useNavigateTo } from '../navigate';
import { MenuItemDivider } from '../notification-menu/notification-menu.styled';
import { ProfileEditModal } from '../profile-edit-modal';
import { MenuButton, MenuItem, StyledStack } from './profile-menu.styled';

export const ProfileMenu = (): ReactElement => {
  const menuState = useMenuState({ gutter: 4 });
  const { user } = useCurrentUser();
  const navigate = useNavigateTo();
  const profileButtonId = useAnalyticId(AnalyticIdentifier.HEADER_PROFILE);
  const logoutButtonId = useAnalyticId(AnalyticIdentifier.HEADER_LOGOUT);
  const profileMenuId = useAnalyticId(AnalyticIdentifier.PROFILE_MENU);

  const { isOpen: isProfileEditModalOpen, setIsOpen: setIsProfileEditModalOpen } = useModal();

  const onHandleEditProfile = (): void => {
    setIsProfileEditModalOpen(true);
    menuState.hide(); // Close the menu when opening the modal
  };

  return (
    <>
      <MenuButton id={profileButtonId} state={menuState}>
        <Avatar size={8} variant="circular" />
      </MenuButton>
      <StyledStack
        as={AriaMenu}
        id={profileMenuId}
        state={menuState}
        backgroundColor={colors.white}
        boxShadow="md"
        borderRadius="md"
        direction="column"
      >
        <Stack paddingX={2} paddingY={2} justifyContent="center">
          <Typography color={colors.gray[600]} fontSize="xs" fontWeight="medium">
            {user?.fullName ?? 'No name'}
          </Typography>
        </Stack>
        <MenuItem onClick={onHandleEditProfile}>
          <Stack paddingY={1} alignItems="center" justifyContent="center" fullWidth>
            <Typography color={colors.gray[600]} fontSize="xs" fontWeight="medium">
              Edit Profile
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItemDivider />
        <MenuItem id={logoutButtonId} onClick={(): void => navigate(getPath({ path: Path.LOGOUT }))}>
          <Stack paddingY={1} alignItems="center" justifyContent="center" fullWidth>
            <Typography fontSize="sm" color={colors.gray[600]}>
              Log out
            </Typography>
          </Stack>
        </MenuItem>
      </StyledStack>

      {user && (
        <ProfileEditModal userId={user.id} isOpen={isProfileEditModalOpen} setIsOpen={setIsProfileEditModalOpen} />
      )}
    </>
  );
};
